import { NavbarScroller } from './NavbarScroller';

declare let Spinner: any;

if (!(window as any).CM) (window as any).CM = {};
const CM = (window as any).CM;
if (!CM.tool) CM.tool = {};

if (!CM.tool.page) {
    CM.tool.page = {
        changeLanguage: (lang) => {
            const url = '/global/endpoints/user-notifications/?f=cl&l=' + lang;
            $.get(url, (data) => {
                // @ts-ignore
                window.location.reload(true);
            });
        },
        renameSurvey: (surveyId) => {
            surveyId = surveyId || CM.tool.page.survey.id;
            const sUrl = '/tool/surveys/manage/edit/title-modal/?survey=' + surveyId;
            $.get(sUrl, (data) => {
                const content = data;
                $('body').append(content);
                ($('#surveyTitleModal') as any).modal();
                $('#surveyTitleModal').on('hidden.bs.modal', () => {
                    $('#surveyTitleModal').remove();
                });
            });
        },
        upgradeSurvey: (surveyId, hi) => {
            surveyId = surveyId || CM.tool.page.survey.id;
            const sUrl = '/tool/surveys/manage/upgrade-modal/?survey=' + surveyId;
            $.get(sUrl, (data) => {
                const content = data;
                $('body').append(content);
                ($('#upgradeSurveyModal') as any).modal();
                $('#upgradeSurveyModal').on('hidden.bs.modal', () => {
                    $('#upgradeSurveyModal').remove();
                });
            });
        },
        showModalWindow: (settings) => {
            settings = {
                url: settings.url || '',
                type: settings.type || 'iframe',
                modal: settings.modal || false,
                width: settings.width,
                height: settings.height,
            };
            ($ as any).fancybox.open({
                src: settings.url,
                type: settings.type,
                opts: {
                    modal: settings.modal,
                    iframe: {
                        css: {
                            borderRadius: '4px',
                            width: settings.width,
                            height: settings.height,
                            autoSize: false,
                        },
                    },
                },
            });
        },
        closeModalWindow: () => {
            ($ as any).fancybox.close();
        },
        openDrawer: (settings) => {
            $('body').append(
                '<div class="modal-backdrop fade in"></div><div id="drawer"><iframe src="' +
                    settings.url +
                    '" style="visibility:hidden"></iframe></div>'
            );
            new Spinner({ color: '#337ab7' }).spin(document.getElementById('drawer'));
            setTimeout(() => {
                $('html').addClass('drawer-open');
            }, 1);
        },
        showDrawer: () => {
            $('#drawer').children('.spinner').hide();
            $('#drawer').children('iframe').css('visibility', 'visible');
        },
        closeDrawer: () => {
            $('#drawer').children('iframe').css('visibility', 'hidden');
            $('#drawer').children('.spinner').show();
            $('html').removeClass('drawer-open');
            setTimeout(() => {
                $('.modal-backdrop, #drawer').remove();
            }, 1);
        },
    };

    $(document).ready(() => {
        CM.ux.userDropdown.intialize();
        $('.navbar .upgradeBilling').click(() => {
            window.location.href = '/tool/my-account/billing/subscription/select/';
        });
        $('.navbar .upgradeSurvey').click(() => {
            CM.tool.page.upgradeSurvey();
        });
        $('.surveyNav .name').click(() => {
            CM.tool.page.renameSurvey();
        });
        $('.surveyNav .status').click(() => {
            window.location.href = '/tool/surveys/manage/distribute/?survey=' + CM.tool.page.survey.id;
        });
        setTimeout(() => {
            $('#sliding_top_bar').slideDown('slow');
        }, 1000);

        // Stop FancyBox from listening to clicks on elements with the data-trigger attribute.
        $(document).off('click.fb-start', '[data-trigger]');

        const languageList = document.getElementById('languageList');
        const languageBtn = document.getElementById('navToolLanguage');

        if (languageBtn != null) {
            languageBtn.onclick = function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (languageList.style.display === 'none') {
                    languageList.style.display = 'block';
                    languageBtn.classList.add('expanded');
                } else {
                    languageList.style.display = 'none';
                    languageBtn.classList.remove('expanded');
                }
            };
        }

        NavbarScroller.initialize();
    });
}
